import styled from "styled-components";

import { Button } from "@formant/ui-kit";
import { Icon } from "@formant/ui/component/common/Icon";
import { Typography } from "@formant/ui/component/common/Typography";

const dropDownBreakpoint = "875px";

export const TabContainer = styled.nav`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-left: 1.875rem;
    @media (max-width: 480px) {
        padding: 0;
    }
`;

export const LongMenu = styled.ul<{ isOverflowing?: boolean }>`
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style-type: none;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    position: relative;
    overflow: ${({ isOverflowing }) => (isOverflowing ? "visible" : "hidden")};
    & > a {
        width: 10rem;
        color: var(--formant-color-primary-silver);
        & > li {
            display: flex;
            /* justify-content: center; */
            max-width: 100%;
            border-left: none;
            & > span {
                max-width: calc(100% - 30px);
                text-transform: capitalize;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
    & > :last-child {
        width: auto;
    }
    @media (max-width: 545px) {
        margin: 0 0 0 1rem;
        & > a {
            width: 5.625rem;
            & > li {
                margin: 0.9375rem 0.3125rem;
            }
        }
    }

    & > a {
        color: var(--formant-color-primary-silver);
        & > li {
            border-left: none;
        }
    }
`;

export const AddViewButton = styled.a`
    white-space: nowrap;
    position: absolute;
    top: 0;
    right: 0.9375rem;
    height: 100%;
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
    cursor: pointer;
    &:hover {
        & > svg {
            fill: #fff;
            & > rect {
                fill: #fff;
            }
            & > path {
                stroke: #fff;
            }
        }
    }
`;

export const Item = styled.li<{ isActive?: boolean; hasText?: boolean }>`
    ${({ hasText }) => !hasText && "width:auto;"}
    white-space: nowrap;
    height: 2.5rem;
    display: flex;
    align-items: center;
    margin: 15px 8px;
    cursor: pointer;
    border-left: 0.1875rem solid #0a0b10;
    ${props =>
        props.isActive &&
        "border-left: 0.1875rem solid var(--formant-color-highlights-blue);" +
            "border-bottom: 2px solid var(--formant-color-highlights-blue);" +
            "& > svg {fill: #fff;& > rect {fill: #fff;}& > path {stroke: #fff;};};" +
            "& > span {color: #fff;};"}

    &:hover {
        border-bottom: 0.125rem solid var(--formant-color-highlights-blue);
        & > svg {
            fill: #fff;
            & > rect {
                fill: #fff;
            }
            & > path {
                stroke: #fff;
            }
        }
    }
`;

export const ItemLabel = styled(Typography)`
    color: var(--formant-color-primary-silver);
    text-transform: capitalize;
    @media (max-width: 480px) {
        font-size: 12px;
    }
    &:hover {
        color: #fff;
    }
`;

export const DropdownButton = styled.span`
    display: flex;
    height: 2.5rem;
    width: auto;
    padding: 0 0.625rem 0 0.3125rem;
    margin: 0.9375rem 0 0 0;
    align-items: center;
    cursor: pointer;
    white-space: nowrap;
    border-radius: 0.25rem 0.25rem 0 0;
    @media (max-width: 545px) {
        width: 1.5rem;
        padding: 0 0;
    }
`;

export const DropdownContainer = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
`;

export const DropdownSideContainer = styled(DropdownContainer)`
    @media (min-width: 590px) {
        display: none;
    }
`;

export const DropdownList = styled.ul`
    top: 4.375rem;
    position: absolute;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    background-color: #0a0b10;
    border: 1px solid var(--formant-color-highlights-blue);
    border-radius: 0 0 0.25rem 0.25rem;
    max-height: 15rem;
    max-width: 14.5rem;
    overflow-y: auto;
    overflow-x: hidden;
    right: 0;

    @media (max-width: 590px) {
        width: 18.75rem;
    }
    & > a {
        color: var(--formant-color-primary-silver);
        &:first-child {
            border-bottom: 1px solid var(--formant-color-primary-silver);
        }
        & > li {
            max-width: 11.875rem;
            text-overflow: ellipsis;
            margin: 0.3125rem 0;
            padding: 0 0.8125rem 0 0.625rem;
            border-bottom: none;

            & > span {
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
            &:hover {
                border-left: 0.1875rem solid
                    var(--formant-color-highlights-blue);
                border-bottom: none;
                & > span {
                    color: #fff;
                }
            }
        }
    }
`;

export const AddViewDropdown = styled.a`
    display: flex;
    justify-content: space-between;
    & > span {
        margin-right: 0.875rem;
    }
    & > :last-child {
        display: flex;
        align-items: center;
    }
`;

export const SideMenu = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    gap: 0.625rem;
`;

export const SideMenuIcon = styled.button`
    display: none;
    height: 2rem;
    width: 2rem;
    padding: 0;
    background-color: var(--formant-color-primary-steel02);
    border-radius: 6.25rem;
    border: none;
    @media (max-width: ${dropDownBreakpoint}) {
        display: block;
    }
`;

export const SideMenuButton = styled(Button)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 7.5rem;
    height: 2rem;
    & > svg {
        fill: #000;
        margin-right: 0.375rem;
    }
    @media (max-width: ${dropDownBreakpoint}) {
        display: none;
    }
`;

export const SideMenuDropdown = styled.ul`
    position: absolute;
    top: 2.5rem;
    right: 0;
    list-style-type: none;
    margin: 0;
    padding: 0.313rem 0;
    background-color: #0a0b10;
    border: 1px solid var(--formant-color-highlights-blue);
    border-radius: 0 0 0.25rem 0.25rem;
    display: flex;
    flex-direction: column;
    color: var(--formant-color-primary-silver);
    li {
        cursor: pointer;
        display: flex;
        align-items: center;
        width: 8.75rem;
        margin: 0.313rem 0;
        padding: 0 0.813rem 0 0.625rem;
        & > span {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
        &:hover {
            border-left: 0.188rem solid var(--formant-color-highlights-blue);
            border-bottom: none;
            & > span {
                color: #fff;
            }
        }
    }
    hr {
        margin: 0.3125rem 0.8125rem 0.3125rem 0.625rem;
        width: calc(100% - 1.4375rem);
        border: none;
        border-bottom: 1px solid var(--formant-color-primary-steel03);
    }
`;

export const StyledIcon = styled(Icon)`
    margin-right: 0.375rem;
`;

export const FilterWrapper = styled.div`
    flex-grow: unset;
    display: grid;
    grid-auto-flow: column;
    grid-gap: 0.625rem;
    align-items: center;
`;

export const DesktopButton = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 0.625rem;
    & > button {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 2rem;
        width: 2rem;
        & > svg {
            height: 1rem;
            width: 1rem;
        }
    }
    & > :first-child {
        & > svg {
            height: 1.5rem;
            width: 1.5rem;
        }
    }
    @media (max-width: 590px) {
        display: none;
    }
`;
export const DesktopSideMenuDropdown = styled(SideMenuDropdown)`
    @media (max-width: 590px) {
        display: none;
    }
`;
